export * from './InstagramIcon'
